import React from 'react';
import Tooltip from './Tooltip';
import { colors } from '../global/variables';

interface TooltipTotalizerProps {
    kwh: string;
    position?: 'top' | 'bottom' | 'left' | 'right';
}

const TooltipTotalizer: React.FC<TooltipTotalizerProps> = ({
    kwh,
    position = 'top',
}) => {
    return (
        <Tooltip
            content={`${kwh} kWh`}
            position={position}
            size="small"
            iconColor={colors.inactiveWhite}
            iconStroke={colors.inactiveWhite}
        />
    );
};

export default TooltipTotalizer;
